import { CmcWebApi, CmcWebApiCommon } from '@cmctechnology/webinvest-api-client-web-trading';
import { frontendActions, getConfig, LocationType } from '@cmctechnology/webinvest-store-frontend';
import { ResourceKey } from '@cmctechnology/webinvest-store-frontend/dist/js/models/subscriptions';
import { Dispatch } from '@reduxjs/toolkit';
import { ApiRequest } from './models/apiRequest';
import { CLIENT_STORE_NAME, actions } from './store';
import { ClientProfileSettingSave1, StockLendingSettings, ProfileSetting } from './types';

export const fetchClientProfileSettings = (profileSettings: ProfileSetting[]) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const request: CmcWebApi.Client.ClientProfileSettingGetRequest1 = {
        Settings: profileSettings
      };
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Client.ClientPreferencesModel1>(
        CLIENT_STORE_NAME,
        ApiRequest.ClientProfileSettingGet1,
        request,
        dispatch
      );
      dispatch<any>(actions.profileSettingsFetched(response.Settings));
    } catch {}
  };
};

// eslint-disable-next-line unicorn/consistent-function-scoping
export const onPollClientProfileSettings = (subscriptions: ResourceKey[] = []) => {
  if (subscriptions.length === 0) return () => {};
  return (dispatch: Dispatch<any>) => {
    dispatch<any>(fetchClientProfileSettings(subscriptions as ProfileSetting[]));
  };
};

export const subscribeClientProfileSettings = (location: LocationType, profileSettings: ProfileSetting[]) => (dispatch: Dispatch<any>) => {
  dispatch<any>(
    frontendActions.subscribe({
      onPoll: onPollClientProfileSettings,
      location,
      apiName: ApiRequest.ClientProfileSettingGet1,
      storeName: CLIENT_STORE_NAME,
      resourceKeys: profileSettings as ResourceKey[],
      pollTimeout: getConfig().pollTimeout
    })
  );
};

export const unsubscribeClientProfileSettings = (location: LocationType, profileSettings: ProfileSetting[]) => (dispatch: Dispatch<any>) => {
  dispatch<any>(
    frontendActions.unsubscribe({
      location,
      apiName: ApiRequest.ClientProfileSettingGet1,
      storeName: CLIENT_STORE_NAME,
      resourceKeys: profileSettings as ResourceKey[]
    })
  );
};

export const saveProfileSettings = (request: ClientProfileSettingSave1) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApiCommon.Shared.OperationResultModel1>(
        CLIENT_STORE_NAME,
        ApiRequest.ClientProfileSettingSave1,
        request,
        dispatch
      );
      dispatch<any>(actions.clientProfileSettingsSaved({ result: response, profileSettings: request }));
      return response;
    } catch {}
  };
};

export const getStockLendingSettings = () => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const request = {};
      const response = await frontendActions.webTradingApiCall<StockLendingSettings>(
        CLIENT_STORE_NAME,
        ApiRequest.StockLendingShowInterceptorGet1,
        request,
        dispatch
      );
      dispatch<any>(actions.stockLendingSettingsFetched(response));
    } catch {}
  };
};
